import home from './home';
import familiesList from './familiesList';
import label from './label';
import general from './general';
import family from './family';
import errorPages from './errorPages';
import thanks from './thanks';
import form from './form';
import footer from './footer';
import banners from './banners';

export default {
    ...general,
    ...home,
    ...familiesList,
    ...label,
    ...family,
    ...errorPages,
    ...thanks,
    ...form,
    ...footer,
    ...banners
};
